export const downloadImageFile = (fileName: string, file: string) => {
  const link = document.createElement('a');
  link.href = file;
  link.download = `${fileName}-${Date.now()}`;
  link.click();
};

export const downloadFile = (data: string | Blob, filename: string, fileType: string = 'application/json') => {
  const blob = new Blob([data], { type: fileType });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
};
